import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./PropertyPage.css";

// ─── AMENITY ICON MAP ─────────────────────────────────────────────────────────
// Maps amenity names to inline SVG icons (booking.com style line icons).
// Matching is case-insensitive and partial, so "Free WiFi" still matches "wifi".
const AMENITY_ICONS = {
  wifi:        '<path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/>',
  parking:     '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 17V7h4a3 3 0 0 1 0 6H9"/>',
  pool:        '<path d="M2 12h20"/><path d="M2 16h20"/><path d="M2 20h20"/><path d="M6 12V4a2 2 0 0 1 4 0v8"/><path d="M14 12V4a2 2 0 0 1 4 0v8"/>',
  kitchen:     '<path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>',
  ac:          '<rect x="2" y="4" width="20" height="6" rx="2"/><path d="M6 14v.5"/><path d="M10 14v1.5"/><path d="M14 14v1.5"/><path d="M18 14v.5"/><path d="M6 18v.5"/><path d="M18 18v.5"/>',
  airport:     '<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>',
  balcony:     '<path d="M3 21h18"/><path d="M5 21V10l7-5 7 5v11"/><path d="M9 21v-6h6v6"/>',
  seaview:     '<circle cx="12" cy="8" r="3"/><path d="M2 18c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2 2-2 4-2"/><path d="M2 22c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2 2-2 4-2"/>',
  garden:      '<path d="M12 22V12"/><path d="M12 12c0-3 2-5 5-5 0 3-2 5-5 5Z"/><path d="M12 14c0-3-2-5-5-5 0 3 2 5 5 5Z"/>',
  family:      '<circle cx="9" cy="7" r="3"/><circle cx="17" cy="9" r="2"/><path d="M3 21v-2a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v2"/><path d="M16 14a4 4 0 0 1 5 4v3"/>',
  nonsmoking:  '<circle cx="12" cy="12" r="10"/><line x1="4.9" y1="4.9" x2="19.1" y2="19.1"/>',
  tv:          '<rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>',
  breakfast:   '<path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4Z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/>',
  heating:     '<path d="M12 2v8"/><path d="m4.93 10.93 1.41 1.41"/><path d="M2 18h2"/><path d="M20 18h2"/><path d="m19.07 10.93-1.41 1.41"/><path d="M22 22H2"/><path d="m8 6 4-4 4 4"/><path d="M16 18a4 4 0 0 0-8 0"/>',
  washer:      '<rect x="3" y="2" width="18" height="20" rx="2"/><circle cx="12" cy="13" r="5"/><line x1="8" y1="6" x2="8.01" y2="6"/><line x1="12" y1="6" x2="12.01" y2="6"/>',
  pets:        '<circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/>',
  gym:         '<path d="m6.5 6.5 11 11"/><path d="m21 21-1-1"/><path d="m3 3 1 1"/><path d="m18 22 4-4"/><path d="m2 6 4-4"/><path d="m3 10 7-7"/><path d="m14 21 7-7"/>',
  default:     '<circle cx="12" cy="12" r="9"/><path d="m9 12 2 2 4-4"/>',
};

function iconFor(name) {
  const n = String(name).toLowerCase();
  if (n.includes("wifi") || n.includes("internet")) return AMENITY_ICONS.wifi;
  if (n.includes("parking")) return AMENITY_ICONS.parking;
  if (n.includes("pool")) return AMENITY_ICONS.pool;
  if (n.includes("kitchen")) return AMENITY_ICONS.kitchen;
  if (n.includes("air") || n.includes("a/c") || n.includes("conditioning")) return AMENITY_ICONS.ac;
  if (n.includes("airport") || n.includes("shuttle")) return AMENITY_ICONS.airport;
  if (n.includes("balcony") || n.includes("terrace")) return AMENITY_ICONS.balcony;
  if (n.includes("sea") || n.includes("lake") || n.includes("view")) return AMENITY_ICONS.seaview;
  if (n.includes("garden")) return AMENITY_ICONS.garden;
  if (n.includes("family")) return AMENITY_ICONS.family;
  if (n.includes("non-smoking") || n.includes("non smoking") || n.includes("nonsmoking")) return AMENITY_ICONS.nonsmoking;
  if (n.includes("tv") || n.includes("television")) return AMENITY_ICONS.tv;
  if (n.includes("breakfast")) return AMENITY_ICONS.breakfast;
  if (n.includes("heat")) return AMENITY_ICONS.heating;
  if (n.includes("wash") || n.includes("laundry")) return AMENITY_ICONS.washer;
  if (n.includes("pet")) return AMENITY_ICONS.pets;
  if (n.includes("gym") || n.includes("fitness")) return AMENITY_ICONS.gym;
  return AMENITY_ICONS.default;
}

export default function PropertyPage() {
  var params = useParams();
  var [property, setProperty] = useState(null);
  var [loading, setLoading] = useState(true);
  var [activeRoom, setActiveRoom] = useState(null);
  var [activePhotoIndex, setActivePhotoIndex] = useState(0);

  useEffect(function () {
    window.scrollTo(0, 0);
    fetch("/api/properties/" + params.slug)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        setProperty(data.property || data);
        setLoading(false);
      })
      .catch(function (err) {
        console.error("Failed to load property", err);
        setLoading(false);
      });
  }, [params.slug]);

  useEffect(function () {
    if (activeRoom) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return function () { document.body.style.overflow = ""; };
  }, [activeRoom]);

  function openRoom(room) {
    setActiveRoom(room);
    setActivePhotoIndex(0);
  }

  function closeRoom() {
    setActiveRoom(null);
    setActivePhotoIndex(0);
  }

  function prevPhoto(e) {
    e.stopPropagation();
    setActivePhotoIndex(function (i) {
      return i === 0 ? activeRoom.images.length - 1 : i - 1;
    });
  }

  function nextPhoto(e) {
    e.stopPropagation();
    setActivePhotoIndex(function (i) {
      return i === activeRoom.images.length - 1 ? 0 : i + 1;
    });
  }

  if (loading) return <div className="not-found container"><p>Loading...</p></div>;
  if (!property) return <div className="not-found container"><h2>Property not found</h2></div>;

  var rooms = property.rooms && property.rooms.length > 0 ? property.rooms : [];
  var amenities = property.amenities || [];

  return (
    <div className="property-page">

      {/* HERO */}
      <div className="prop-hero">
        {property.heroVideo ? (
          <video className="prop-hero-video" src={property.heroVideo} autoPlay muted loop playsInline />
        ) : (
          <div className="prop-hero-bg" style={{ backgroundImage: "url(" + property.heroImage + ")" }} />
        )}
        <div className="prop-hero-overlay" />
        <div className="prop-hero-content">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">{property.type}</span></div>
          <h1>{property.name}</h1>
          <p>{property.location}</p>
        </div>
      </div>

      {/* MAIN */}
      <div className="prop-main container">
        <div className="prop-detail">
          <div className="prop-info">
            <div className="prop-rating-row">
              <span className="star-rating">&#9733; {property.rating}</span>
              <span className="review-count">({property.reviewCount} reviews)</span>
              <span className="price-from">from {property.priceFrom} EUR/night</span>
            </div>
            <h2>{property.tagline}</h2>
            <p className="prop-desc">{property.description}</p>
          </div>

          <div className="prop-booking-box">
            <div className="booking-price-row">
              <span className="booking-from">from</span>
              <span className="booking-price">{property.priceFrom} EUR</span>
              <span className="booking-per">/night</span>
            </div>
            <div className="booking-rating">&#9733; {property.rating} &nbsp; ({property.reviewCount} reviews)</div>
            <a href={property.beds24Url} target="_blank" rel="noreferrer" className="booking-btn">Check Availability</a>
            <p className="booking-note">Secure booking via Beds24</p>
          </div>
        </div>

        {/* ROOMS GALLERY */}
        {rooms.length > 0 && (
          <div className="prop-gallery">
            {rooms.map(function (room, i) {
              var coverImg = (room.images && room.images[0]) || null;
              return (
                <div key={i} className="gallery-item" onClick={function () { openRoom(room); }}>
                  {coverImg
                    ? <img src={coverImg} alt={room.label || property.name} className="gallery-img" />
                    : <div className="gallery-img-placeholder" />
                  }
                  {room.label && <div className="gallery-label">{room.label}</div>}
                  <div className="gallery-hover-hint">View Room</div>
                </div>
              );
            })}
          </div>
        )}

        {/* AMENITIES — booking.com style, below room photos */}
        {amenities.length > 0 && (
          <div className="prop-amenities-section">
            <h3 className="prop-amenities-title">Most popular facilities</h3>
            <div className="prop-amenities-grid">
              {amenities.map(function (a, i) {
                return (
                  <div key={i} className="prop-amenity-box">
                    <svg
                      className="prop-amenity-icon"
                      width="22" height="22" viewBox="0 0 24 24"
                      fill="none" stroke="currentColor" strokeWidth="1.6"
                      strokeLinecap="round" strokeLinejoin="round"
                      dangerouslySetInnerHTML={{ __html: iconFor(a) }}
                    />
                    <span className="prop-amenity-label">{a}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* ROOM MODAL */}
      {activeRoom && (
        <div className="room-modal-overlay" onClick={closeRoom}>
          <div className="room-modal" onClick={function (e) { e.stopPropagation(); }}>
            <button className="room-modal-close" onClick={closeRoom}>×</button>

            <div className="room-modal-img-wrap">
              {activeRoom.images && activeRoom.images.length > 0 ? (
                <>
                  <img
                    src={activeRoom.images[activePhotoIndex]}
                    alt={activeRoom.label || "Room"}
                    className="room-modal-img"
                  />
                  {activeRoom.images.length > 1 && (
                    <>
                      <button className="room-modal-nav room-modal-prev" onClick={prevPhoto}>‹</button>
                      <button className="room-modal-nav room-modal-next" onClick={nextPhoto}>›</button>
                      <div className="room-modal-dots">
                        {activeRoom.images.map(function (_, idx) {
                          return (
                            <button
                              key={idx}
                              className={"room-modal-dot" + (idx === activePhotoIndex ? " active" : "")}
                              onClick={function (e) { e.stopPropagation(); setActivePhotoIndex(idx); }}
                            />
                          );
                        })}
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div className="gallery-img-placeholder" />
              )}
            </div>

            <div className="room-modal-body">
              {activeRoom.label && <h2 className="room-modal-title">{activeRoom.label}</h2>}
              {activeRoom.description && <p className="room-modal-desc">{activeRoom.description}</p>}
              <a href={property.beds24Url} target="_blank" rel="noreferrer" className="booking-btn room-modal-btn">
                Check Availability
              </a>
              <p className="booking-note room-modal-note">Secure booking via Beds24</p>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}